import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { SharedState } from "../../../../context/SharedContext";
import { PROFILES } from "../../../../enums/PROFILES.enum";
import { useSelectLayout } from "../../../../hooks/useSelectLayout";
import { encryptData } from "../../../../utils/token.util";
import { LoadingSpinner2 } from "../../../Loading/styled";
import { SelectedUserProps } from "./selected-user";
import * as S from "./styled";

interface SelectUserProps {
  isSetorCorregedoria?: boolean;
}

export const SelectUser = ({ isSetorCorregedoria }: SelectUserProps) => {
  const { user, selectedUser, setSelectedUser } = SharedState();
  const { usersList, isLoadingUsersList } = useSelectLayout(
    +user["jvris.User.Perfil"],
    +user["Jvris.User.Id"],
    isSetorCorregedoria,
  );

  let options = usersList;

  if (!isLoadingUsersList) {
    if (
      (+user["jvris.User.Perfil"] === PROFILES.PROCURADOR &&
        !isSetorCorregedoria) ||
      usersList?.length === 0 ||
      usersList === undefined
    ) {
      options = [
        {
          label: user["Jvris.User.Name"],
          value: +user["Jvris.User.Id"],
          id: +user["Jvris.User.Id"],
        },
      ];
    }
  }

  useEffect(() => {
    if (isLoadingUsersList) return;
    if (selectedUser) return;
    if (!options || options.length === 0) return;

    const perfil = +user["jvris.User.Perfil"];

    // CASO 1 — Procurador na Corregedoria → seleciona ELE MESMO
    if (perfil === PROFILES.PROCURADOR && isSetorCorregedoria) {
      const selfOption = options.find((u) => u.id === +user["Jvris.User.Id"]);

      if (!selfOption) return;

      setSelectedUser({
        name: selfOption.label,
        id: selfOption.id,
      });

      try {
        const token = encryptData(
          selfOption.id,
          selfOption.label,
          +user["Jvris.User.SessionCreation"],
        );
        localStorage.setItem("selectedUser", token);
      } catch (error) {}

      return;
    }

    // CASO 2 — Analista ou Assessor → seleciona PRIMEIRO DA LISTA
    if (
      perfil === PROFILES.ANALISTA ||
      perfil === PROFILES.ASSESSOR_DE_PROCURADOR ||
      perfil === PROFILES.ASSESSOR_PROCURADOR ||
      perfil === PROFILES.OPERADOR_ASSESSOR_DO_PROCURADOR
    ) {
      const firstOption = options[0];

      if (!firstOption) return;

      setSelectedUser({
        name: firstOption.label,
        id: firstOption.id,
      });

      try {
        const token = encryptData(
          firstOption.id,
          firstOption.label,
          +user["Jvris.User.SessionCreation"],
        );

        localStorage.setItem("selectedUser", token);
      } catch (error) {}

      return;
    }

    // Caso padrão (ex: Procurador fora da Corregedoria)
    // Aqui normalmente nem aparece select, mas por segurança:
    if (options.length === 1) {
      const onlyOption = options[0];

      setSelectedUser({
        name: onlyOption.label,
        id: onlyOption.id,
      });

      try {
        const token = encryptData(
          onlyOption.id,
          onlyOption.label,
          +user["Jvris.User.SessionCreation"],
        );
        localStorage.setItem("selectedUser", token);

        console.log(token);
      } catch (error) {}
    }
  }, [isLoadingUsersList, options, selectedUser, isSetorCorregedoria, user]);

  const handleSelectionChange = (selectedUser: SelectedUserProps) => {
    setSelectedUser({
      name: selectedUser.label,
      id: selectedUser.id,
    });
    try {
      const token = encryptData(
        selectedUser.id,
        selectedUser.label,
        +user["Jvris.User.SessionCreation"],
      );
      localStorage.setItem("selectedUser", token);
    } catch (error) {
      //console.log(error);
    }
  };

  const { control } = useForm<any>({
    mode: "onChange",
  });

  return (
    <S.Container>
      {!isLoadingUsersList ? (
        <Controller
          name="usuario"
          control={control}
          render={({ field }) => (
            <S.CustomSelect
              {...field}
              isLoading={isLoadingUsersList}
              options={options}
              value={
                selectedUser
                  ? options.find((u) => u.id === selectedUser.id)
                  : null
              }
              onChange={(option: SelectedUserProps) => {
                handleSelectionChange(option);
                field.onChange(option);
              }}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                  fontSize: "3.2rem",
                }),
              }}
            />
          )}
        />
      ) : (
        <LoadingSpinner2 />
      )}
    </S.Container>
  );
};
